type RevisionConversationVersion = {
  createdAt: Date | string | null;
};

export function sortEmailExpress2VersionsChronologically<T extends RevisionConversationVersion>(
  versions: readonly T[],
): T[] {
  return [...versions].sort((left, right) => {
    const leftTime = left.createdAt ? new Date(left.createdAt).getTime() : 0;
    const rightTime = right.createdAt ? new Date(right.createdAt).getTime() : 0;
    return leftTime - rightTime;
  });
}